import React, { useCallback, useMemo, useState } from 'react';


export function useShowOnHover(override?: boolean) {
    const [fadeIn, setFadeIn] = useState(false);
    const [fadeShow, setFadeShow] = useState(false);

    const onHover = useCallback(() => {
        setFadeIn(true);
    }, []);

    const onLeave = useCallback(() => {
        setFadeIn(false);
    }, []);

    const hoverEvents = useMemo(() => {
        return {
            onMouseEnter: onHover,
            onMouseLeave: onLeave
        };
    }, [onHover, onLeave]);

    const onAnimationStart = useCallback((e: React.AnimationEvent) => {
        if (e.animationName === 'lcms-fade-in') {
            setFadeShow(true);
        }
    }, []);
    const onAnimationEnd = useCallback((e: React.AnimationEvent) => {
        if (e.animationName === 'lcms-fade-out') {
            setFadeShow(false);
        }
    }, []);

    const effectiveFadeIn = typeof (override) === 'undefined' ? fadeIn : override;

    return {
        hoverEvents,
        className: 'lcms-fade' + (effectiveFadeIn ? ' lcms-fade-in' : '') + (fadeShow ? ' lcms-fade-show' : ''),
        onAnimationStart,
        onAnimationEnd
    };
}
